import { FormControl } from '@angular/forms';
import { DescricaoAtributo } from '../functions/DescricaoAtributo';
import { AssuntoDTO } from './AssuntoDTO';
import { Classificacao } from './Classificacao';

@DescricaoAtributo({
  nome: 'Nome do Usuário',
  email: 'Email do Usuário',
  nomeElogiado: 'Nome do Elogiado',
  descricaoElogio: 'Descrição do Elogio',
  listaClassificacao: 'Assunto(s)',
  assunto: 'Assunto',
})
export class ElogioVO {
  id: number;
  username: FormControl | string = '';
  dataHoraAbertura: Date;
  nome: FormControl | string;
  email: FormControl | string;
  descricaoElogio: FormControl | string;

  nomeElogiado: FormControl | string;

  listaClassificacao: FormControl | Classificacao[];
  listaClassificacaoCompleta: Classificacao[];

  files: any[] = [];

  assunto: FormControl | AssuntoDTO;
  assuntos: AssuntoDTO[];

  demandaRecebida: FormControl | string = '';
}
